let apolloClientInstance;

export const setClient = client => {
  apolloClientInstance = client;
};

export const store = () => {
  if (!apolloClientInstance) {
    throw new Error(
      '[moveiq-app]  attempted to access client store instance before it was initialized'
    );
  }
  return apolloClientInstance;
};

export const apolloStore = store;
